export const DummyDepartments = {departments:[  "Quality Systems", "Quality Control", "Production", "Materials Management", "Maintenance", "Facilities & Utilities", "Validation & Qualification", "Personnel", "HSE", "Others",  "Research", ]}
export const autoLogoutMinutes = 30;
export const adminOnly = 'admin';